import { render, staticRenderFns } from "./QuestionAnalysis.vue?vue&type=template&id=8629a3d2&scoped=true&"
import script from "./QuestionAnalysis.vue?vue&type=script&lang=js&"
export * from "./QuestionAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAnalysis.vue?vue&type=style&index=0&id=8629a3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8629a3d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSelect})
